import styled from 'styled-components';
import { DetailDataProps } from '../data';
import { RowTable } from '../../../func/components/Table';
import { ReportFormatNumber } from '../../../func/Function';

interface Props {
  data: DetailDataProps;
}

function BasicInfo({ data }: Props) {
  const rendingData = [
    { key: '소재지', value: data.addr },
    {
      key: '경매접수',
      value: data.reg_date ? data.reg_date.split('T')[0] : '-',
    },
    {
      key: '경매개시결정일',
      value: data.dec_date ? data.dec_date.split('T')[0] : '-',
    },
    {
      key: '배당요구종기일',
      value: data.div_date ? data.div_date.split('T')[0] : '-',
    },
    { key: '채무자', value: data.debtor ?? '-' },
    { key: '소유자', value: data.owner ?? '-' },
    { key: '채권자', value: data.creditor ?? '-' },
    { key: '청구금액', value: ReportFormatNumber(data.billing_price) },
  ];

  return (
    <Container id="물건기본정보">
      <div>물건기본정보</div>
      <RowTable data={rendingData} titleWidth={110} />
    </Container>
  );
}

export default BasicInfo;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 32px 16px;
  background-color: #fff;
  gap: 24px;
  color: #222222;
  font-size: 18px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 700;
  line-height: 26.1px;
  word-wrap: break-word;
`;
